<template>
  <div class="table-responsive">
    <table :id="id" class="table w-100 table-striped" :class="tableClass" style="table-layout: fixed;">
      <thead :class="headVariant === 'light' ? 'thead-light' : ''">
        <tr>
          <th
            v-for="field in visible_fields"
            :key="field.key"
            @click="toggle_sort(field)"
            :class="field.thClass || null"
            :style="{ cursor: field.sortable ? 'pointer' : 'default' }"
          >
            {{ field.label }}
            <span v-if="field.sortable">
              <i v-if="sort_by === field.key && !sort_desc" class="fa fa-sort-up ml-1"></i>
              <i v-else-if="sort_by === field.key && sort_desc" class="fa fa-sort-down ml-1"></i>
              <i v-else class="fa fa-sort ml-1"></i>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="is_loading">
          <td :colspan="visible_fields.length" class="text-center">Loading...</td>
        </tr>
        <tr v-else-if="internal_items.length === 0">
          <td :colspan="visible_fields.length" class="text-center">No data</td>
        </tr>
        <tr
          v-for="(item, index) in internal_items"
          :key="item.id || index"
          :class="tbodyTrClass ? tbodyTrClass(item) : null"
          @click="row_clicked(item, index)"
        >
          <td
            v-for="field in visible_fields"
            :key="field.key"
            :class="field.tdClass || null"
          >
            <slot :name="`cell(${field.key})`" v-bind="{ item, index, field, value: field.formatter ? field.formatter(null, null, item) : item[field.key] }">
              {{ field.formatter ? field.formatter(null, null, item) : item[field.key] }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'MemlistAjaxTable',
  props: {
    id: String,
    fields: Array,
    items: Function,
    per_page: Number,
    current_page: Number,
    headVariant: String,
    tbodyTrClass: Function,
    tableClass: [String, Object, Array],
  },
  data() {
    return {
      internal_items: [],
      sort_by: null,
      sort_desc: false,
      is_loading: false,
    }
  },
  computed: {
    visible_fields() {
      return this.fields.filter(f => f.visible !== false)
    },
  },
  emits: ['row-clicked','sort-changed'],
  watch: {
    per_page: 'load_items',
    current_page: 'load_items',
    sort_by: 'load_items',
    sort_desc: 'load_items',
  },
  methods: {
    refresh() {
      this.load_items();
    },
    toggle_sort(field) {
      if (!field.sortable) {
        return;
      }

      if (this.sort_by === field.key) {
        this.sort_desc = !this.sort_desc;
      } else {
        this.sort_by = field.key;
        this.sort_desc = false;
      }

      this.$emit('sort-changed', {
        sortBy: this.sort_by,
        sortDesc: this.sort_desc,
      });
      
      this.load_items();
    },
    load_items() {
      if (typeof this.items !== 'function') return
      this.is_loading = true
      const ctx = {
        current_page: this.current_page,
        per_page: this.per_page,
        sort_by: this.sort_by,
        sort_desc: this.sort_desc,
      }
      this.items(ctx, (result) => {
        this.internal_items = result || []
        this.is_loading = false
      })
    },
    row_clicked(record, row_index) {
      this.$emit('row-clicked', record, row_index)
    },
  },
  mounted() {
    this.load_items()
  },
}
</script>
